export const consolidationDefaultGridState = {
    "columnVisibility": {
        "hiddenColIds": [
            "lading_uuid",
            "lading_consolidation_uuid"
        ]
    },
    "columnOrder": {
        "orderedColIds": [
            "lading_consolidation_uuid",
            "lading_uuid",
            "alternate_reference",
            "consolidation_id",
            "drop_trailer",
            "pro_bill",
            "delivery_status",
            "carrier_name",
            "load_pallets",
            "shipper_locality",
            "shipper_region",
            "consignee_locality",
            "consignee_region",
            "load_start",
            "load_end",
            "load_length",
            "load_weight",
        ]
    },
    "columnSizing": {
        "columnSizingModel": [
            { "colId": "alternate_reference", "width": 150},
            { "colId": "load_pallets", "width": 80},
            { "colId": "drop_trailer", "width": 120},
            { "colId": "pro_bill", "width": 100},
            { "colId": "delivery_status", "width": 200},
            { "colId": "carrier_name", "width": 250},
            { "colId": "shipper_locality", "width": 120},
            { "colId": "shipper_region", "width": 150},
            { "colId": "consignee_locality", "width": 150},
            { "colId": "consignee_region", "width": 150},
            { "colId": "load_start", "width": 150},
            { "colId": "load_end", "width": 150},
            { "colId": "load_length", "width": 120},
            { "colId": "load_weight", "width": 100},
        ]
    }
}